import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Users } from "lucide-react";
import { api, getUser } from "../api";

// Pulsante "Follower (n)" nell'header privato di pro/struttura: naviga alla pagina dedicata
// (nessun popup/dropdown/pannello flottante). Mostrato solo sul proprio profilo.
export function FollowersButton() {
  const { t } = useTranslation();
  const u = getUser();
  const [count, setCount] = useState(null);
  useEffect(() => {
    api.get("/me/followers").then(({ data }) => setCount(data.count)).catch(() => setCount(null));
  }, []);
  if (!u) return null;
  const to = u.role === "organization" ? `/organizations/${u.id}/followers` : `/professionals/${u.id}/followers`;
  return (
    <Link to={to} className="yp-btn yp-btn-outline" data-testid="followers-btn">
      <Users size={18} className="inline -mt-0.5 mr-1" aria-hidden="true" />{t("followx.followers")}{count != null ? ` (${count})` : ""}
    </Link>);
}
